<template>
  <v-container>
    <h2>고릴라 리서치 체험 서비스</h2>
    <v-divider></v-divider>
    <v-row>     
      <!-- 고릴라 서비스 제목 -->
      <v-col cols="12" class="mb-4">  
        <h1 class="display-2 font-weight-bold mb-3"> 
          <div align="center"></div> </h1>
        <h3 class="display-2 font-weight-thin mb-3 text-center"> 
          <span style="font-weight: 700;"> 
            <v-btn height="54" variant="outlined" color="light-green-darken-4" href="https://cafe.naver.com/gorillaresearch">
              <h4>고릴라리서치 카페</h4>
            </v-btn>
          </span>
        </h3>
      </v-col>

      <!--  ADR 섹션 시작 -->
      <v-col class="mb-5" cols="12"> 
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold"> ADR 지표 서비스 </v-card-title>
          <v-card-subtitle class="text-wrap"> 
            <p>ADR은 상승, 하락 종목수의 비율을 나타내는 지표로 현재 증시가 과매수나 과매도 상태인지를 참고하는 보조 지표입니다.
              ADR이 120 이상이면 과매수권, 80 이하(코스닥 75 이하)면 과매도권에 진입한 것으로 판단합니다.
              <br><br>단 과열시 150을 넘기기도 하고, 금융위기 급의 낙폭을 보일 경우 50 이하로 내려가는 경우도 있습니다.
            </p>
          </v-card-subtitle>
        </v-card>
        <br>
        <!-- ADR 전광판 -->
        <v-card class="mx-auto" width="700" max-width="100%" variant="outlined" color="green-darken-3">
          <v-card-title class="justify-center">오늘의 ADR</v-card-title>
          <v-card-text class="py-0">
            <v-row align="center" no-gutters>
              <v-col class="text-h4 font-weight-bold" cols="6" align="center"><span style="font-size:medium">KOSPI </span>{{ today_ks_adr }}</v-col>
              <v-col class="text-h4 font-weight-bold" cols="6" align="center"><span style="font-size:medium">KOSDAQ </span>{{ today_kq_adr }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- ADR 차트 -->
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-card-item>
            <highcharts :options="chartOptionsADR"></highcharts>      <!-- KOSPI ADR Chart -->
          </v-card-item>
        </v-card>
      </v-col>  
      <!-- ADR 섹션 끝 -->

      <!-- KOSPI PBR 섹션 시작 -->
      <v-col class="mb-5" cols="12"> 
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold"> PBR 지표 서비스 </v-card-title>
          <v-card-subtitle class="text-wrap">
            PBR은 주가를 순자산으로 나눈 값입니다. 이 것을 코스피와 코스닥 전체로 적용한 것이 PBR 지표입니다. 
            <br><br>2000년대 이 후 코스피의 PBR 최저점은 0.71입니다.
            <br><br> 자세한 지표 해설 및 시황 정리는 고릴라 리서치 카페에서 확인하세요.
          </v-card-subtitle>
        </v-card><br>
        <!-- PBR 전광판 -->
        <v-card class="mx-auto" width="700" max-width="100%" variant="outlined" color="green-darken-3">
          <v-card-title class="justify-center">오늘의 PBR</v-card-title>
          <v-card-text class="py-0">
            <v-row align="center" no-gutters>
              <v-col class="text-h4 font-weight-bold" cols="6" align="center"><span style="font-size:medium">KOSPI </span>{{ today_ks_pbr }}</v-col>
              <v-col class="text-h4 font-weight-bold" cols="6" align="center"><span style="font-size:medium">KOSDAQ </span>{{ today_kq_pbr }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- PBR 차트 -->        
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-card-item>
            <highcharts :options="chartOptionsPBR"></highcharts>   <!-- KOSPI PBR Chart -->   
          </v-card-item>
        </v-card>
      </v-col>
      <!-- KOSPI PBR 섹션 종료 -->

            <!-- 주가 예측 섹션 시작 -->
      <v-col class="mb-5" cols="12">
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold"> AI 주가예측 서비스 </v-card-title>
          <v-card-subtitle class="text-wrap">
            주가, 환율, 금리 등의 지표와 금 등 다양한 과거 자산 가격을 학습하여 산출한 인공지능 주가예측 서비스 입니다.
            <br> 고릴라 리서치 선정 500여개 종목이 매 주 업데이트 됩니다. 보유 종목의 향후 추세를 간편하게 예측해 보세요.
            <br><br> 기준일로 부터 30 거래일 간의 주가예측이 제공됩니다.
            <br><br> 서비스를 이용하시려면 고릴라 리서치 카페 회원에 가입하여 주시기 바랍니다.
                    <h3 class="display-2 font-weight-thin mb-3 text-center"> 
                      <span style="font-weight: 700;"> 
                        <v-btn height="54" variant="outlined" color="light-green-darken-4" href="https://cafe.naver.com/gorillaresearch">
                          <h4>고릴라 리서치 카페</h4>
                        </v-btn>
                      </span>
                    </h3><br>
          </v-card-subtitle>
          <v-card-content>
          </v-card-content>
        </v-card>
      </v-col>

      <!-- 예측 종목 검색 시작-->
      <v-col class="mb-5" cols="12" align="center">
        <v-card class="max-auto" width="650" max-width="100%" variant="flat">
          <v-combobox 
            prepend-inner-icon="$vuetify"
            label="종목명" 
            items=""
            variant="underlined" 
            persistent-hint
            :hint="'검색할 종목을 선택하세요'"
            @update:modelValue="onChange"
            return-object>    
          </v-combobox>
        </v-card>
      </v-col>
      <!-- 예측 종목 검색 끝 -->

      <v-col class="mb-5" cols="12" >
        <v-card class="mx-auto" width="700" max-width="100%" variant="outlined" color="green-darken-3">
          <v-card-title class="justify-center">예측 수익률</v-card-title>
          <v-card-text class="py-0">
            <v-row align="center" no-gutters>
              <v-col class="text-h4 font-weight-bold" cols="5" align="center"><span style="font-size:medium; color:red;">1주일 </span><span style="color: red;">**.*% </span></v-col>
              <v-col class="text-h4 font-weight-bold" cols="7" align="center"><span style="font-size:medium; color:blue;">1개월 </span><span style="color: blue;">**.*% </span></v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 예측 차트 -->        
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-card-item>
            <highcharts :options="chartOptionsPRED"></highcharts>   <!-- 예측 Chart -->   
          </v-card-item>
        </v-card>
      </v-col>

    <!-- 수익률 테이블 시작 -->
    <v-card width="700" class="mx-auto" max-width="100%" variant="tonal" color="green-lighten-5"> 
      <v-card-titel class="justify-center text-h5"></v-card-titel>
      <v-data-table style="width: 100%;" :headers="headers" :items="contents" :sort-by="[{key: 'max', order: 'desc'}]">
        <template v-slot:item="{ item }">
          <tr>
            <td> **{{ item.name[1] }}** </td>
            <td> <img :src="item.image" height="45"> </td>
            <td> {{ item.max[0] }}**.*</td>
            <td> {{ item.max_price[0]}}**.*%</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <br><br>
    <!-- 수익률 테이블 끝 -->

    </v-row><br><br>

    <!-- 종목 리포트-->

    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card class="mx-auto" width="700" max-width="100%" variant="flat">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold"> 고릴라 리포트 </v-card-title>

          <v-card-subtitle class="text-wrap">
            고릴라 리서치에서는 우수한 종목이나 현재 이슈가 되는 종목에 대한 리포트를 제공합니다
            <br>개별 종목에 대해 자세하게 공부 해 보세요.
            <br>
            <br>자세한 내용은 고릴라 리서치 멤버쉽 가입 후 열람 가능합니다.
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col> 
        <!-- 종목리포트 1 -->
        <v-card class="mx-auto" width="700" max-width="100%"  variant="outlined" 
                color="green-darken-3" @click.prevent="pageLink">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title>
                <div style="height:50px;">
                  <v-chip class="" size="x-small" label variant="tonal">고릴라 Pick</v-chip>
                  <v-chip class="ma-1" size="x-small" label variant="outlined">스몰캡</v-chip>
                  <v-chip class="" size="x-small" label variant="tonal">이슈</v-chip>
              </div>
                <div>{{ report_title }}</div>
              </v-card-title>
              <v-card-subtitle>
                {{  report_caption }}
              </v-card-subtitle>
            </div>
            <v-avatar class="ma-3" rounded="0" size="100">
              <v-img src="../assets/semicon_img_1.jpg"></v-img>
            </v-avatar>
          </div>
        </v-card>
        <!-- 종목리포트1 끝-->
        <br>
      </v-col>
    </v-row>
    <br>
  </v-container>
</template>

<script>

export default {
  name: 'HelloWorld',

  mounted() {
    this.execKOSPI();
    this.execKOSDAQ();
    this.execPBR();
    this.execList();
    this.execPred();
    this.execTable();
    this.execDefault();
  },

  methods: {
    pageLink() {
      window.open('https://cafe.naver.com/gorillaresearch')
    },
    async execKOSPI() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getADR').then(res => res.json())
        .then(data => this.chartOptionsADR.series[0].data = data)
        .then(data => this.today_ks_adr = JSON.stringify(Math.round(10*data.pop()[1])/10));
    },
    async execKOSDAQ() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getADR2').then(res => res.json())
        .then(data => this.chartOptionsADR.series[1].data = data)
        .then(data => this.today_kq_adr = JSON.stringify(Math.round(10*data.pop()[1])/10));
    },
    async execPBR() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getPBR').then(res => res.json())
        .then(data => this.chartOptionsPBR.series[0].data = data['kospi']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getPBR').then(res => res.json())
        .then(data => this.chartOptionsPBR.series[1].data = data['kosdaq']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getPBR').then(res => res.json())
        .then(data => this.today_ks_pbr = data['kospi'][-1]);
      await fetch('https://www.gorillaresearch.co.kr:5000/getTodayPBR').then(res => res.json())
        .then(data => this.today_ks_pbr = data['kospi']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getTodayPBR').then(res => res.json())
        .then(data => this.today_kq_pbr = data['kosdaq']);
    },

    async execList() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getList').then(res => res.json())
        .then(data => this.chartList = data);
    },
    async execDefault() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json())
          .then(data => this.chartOptionsPRED.series[0].data = data['pred']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json())
          .then(data => this.chartOptionsPRED.title.text = '**'+data['name'][1]+'**');
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json())
          .then(data => this.chartOptionsPRED.subtitle.text = "예측 기준일: " + data['date']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json()) 
          .then(data => this.prediction_max = data['max']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json()) 
          .then(data => this.prediction_min = data['min']);
      await fetch('https://www.gorillaresearch.co.kr:5000/getDefault').then(res => res.json()) 
          .then(data => this.chartOptionsPRED.xAxis.plotBands.from = data['pred'].length-30)
          .then(data => this.chartOptionsPRED.xAxis.plotBands.to = data['pred'].length)
          .then(data => this.chartOptionsPRED.series.zones.value = data['pred'].length-30);
    },
    async execPred(code) {
      try {
        const res = await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code);
        const data = await res.json();
        this.chartOptionsPRED.series[0].data = data['pred'];

        await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code).then(res => res.json()) 
          .then(data => this.chartOptionsPRED.title.text = data['name']);

        await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code).then(res => res.json()) 
          .then(data => this.chartOptionsPRED.subtitle.text = "예측 기준일: " + data['date']);

        await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code).then(res => res.json()) 
          .then(data => this.prediction_max = data['max']);

        await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code).then(res => res.json()) 
          .then(data => this.prediction_min = data['min']);

        await fetch('https://www.gorillaresearch.co.kr:5000/getPred?code='+code).then(res => res.json()) 
          .then(data => this.chartOptionsPRED.xAxis.plotBands.from = data['pred'].length-30)
          .then(data => this.chartOptionsPRED.xAxis.plotBands.to = data['pred'].length)
          .then(data => this.chartOptionsPRED.series.zones.value = data['pred'].length-30);

      }
      catch(err) {
        console.log(err);
      }
    },
 
    async execTable() {
      await fetch('https://www.gorillaresearch.co.kr:5000/getDemoTable').then(res => res.json())
        .then(data => this.contents = data);
    },

    async onChange(selectObj) {
        let code_str = this.chartList.name.indexOf(selectObj);
        await this.execPred(this.chartList.code[code_str])
    },
  },
  props: {
    msg: String
  },
  components: {

  },

  data() {
    return {
      headers: [
        {title: '종목명', value: 'name'},
        {title: '예측 차트', value: 'image'},
        {title: '1주일 수익률', value: 'max'},
        {title: '1개월 수익률', value: 'max_price'},
      ],

      contents: [],

      report_date: "2024년 3월 24일",
      report_title: "AI상용화의 선두주자!",
      report_caption: "동사는 2000년 설립된 AI전문...",

      prediction_date: "",
      prediction_name: "",
      prediction_max: "0.0",
      prediction_min: "0.0",

      today_ks_adr: "",
      today_kq_adr: "",
      today_ks_pbr: "",
      today_kq_pbr: "",

      chartList: [],

      chartOptionsADR: {
        /* 차트 타입, 크기 */
        chart: {
          type: 'line',
          height: 400,

        },
        /* 차트명 */
        title: { text: "ADR Index"},
        /* 부제 */
        subtitle: { text: ""},
        /* x축 */
        xAxis: {
          type: 'datetime',
        },
        /* y축 */
        yAxis: {
          title: { text: "" },
          plotLines: [{
            color: 'red',
            width: 2, 
            value: 120,
            animation: {
              duration: 1000,
              defer: 4000,
            },
            label: {
              text: '과매수',
              align: 'right',
              x: -20,
            }
          },{
            color: 'blue',
            width: 2,
            value: 80,
            animation: {
              duration: 1000,
              defer: 4000,
            },
            label: {
              text: '과매도',
              align: 'right',
              x: -20,
            },
          }],
        },
        /* 범례 속성*/
        legend: {},

        /* 범례, 데이터 값 */
        series: [
          {
            name: "KOSPI",
            marker: {enabled: false},
            color: 'green',
            data: []
          },
          {
            name: "KOSDAQ",
            marker: {enabled: false},
            color: 'orange',
            data: []
          },
        ],
        
        /* 반응형 속성 */
        responsive: {}
      },

      chartOptionsPBR: {
        /* 차트명 */
        title: { text: "PBR Index"},
        /* 부제 */
        subtitle: {},
        /* x축 */
        xAxis: {

        },
        /* y축 */
        yAxis: [{
          title: {text: "KOSDAQ PBR"},
          opposite: true,
        },{
          title: {text: "KOSPI PBR"},
          opposite: false,
        },],
        /* 범례 속성*/
        legend: {},

        /* 범례, 데이터 값 */
        series: [
          {
            name: "KOSPI",
            marker: { enabled: false },
            data: [],
            color: 'green',
            yAxis: 1,
          },
          {
            name: "KOSDAQ",
            marker: { enabled: false },
            data: [],
            color: 'orange',
          },
        ],

        /* 반응형 속성 */
        responsive: {}
      },

      chartOptionsPRED: {
        chart: {
          type: 'line',
          events: {
            load() { },
          },
        },
        /* 차트명 */
        title: { text: ""},
        /* 부제 */
        subtitle: {text: ""},
        /* x축 */
        xAxis: {
          title: {text: ""},
          plotBands: [{
            from: 244,
            to: 274,
            color: 'rgba(68,170,213,0.1)',
            label: {
              text: '예측구간',
              style: {color: '#606060'},
            },
          }],
        },
        /* y축 */
        yAxis: {
          title: {text: "주가", enabled: false},
          labels: { format: "{value:,.0f}"},
          gridLineWidth: 0,
        },
        /* 범례 속성*/
        legend: {},

        lang: { thousandsSep: ','},
  
        /* 범례, 데이터 값 */
        series: [
          {
            animation: { duration: 1000, defer: 1000},
            showInLegend: false,
            name: "",
            color: 'red',
            marker: { enabled: false, radius: 3},
            dashStyle: '',
            data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
            zoneAxis: 'x',
            zones: [{
              value:244, color:'#ABB2B9'
            }]
          },

        ],

        /* 반응형 속성 */
        responsive: {}
      }
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
@import url('https://fonts.googleapis.com/css2?family=Fira+Sans+Extra+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Mali:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap')
</style>
